export default __webpack_public_path__ + "7a36f40beb54a64437a8531d211eeeb8.png";